import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const JotformIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M5.65764 18.8323C6.04716 19.2058 5.77192 19.8458 5.21859 19.8458H1.75683C1.07383 19.8458 0.518066 19.313 0.518066 18.658V15.3382C0.518066 14.8077 1.1855 14.5439 1.57504 14.9173L5.65764 18.8323Z"
      fill="#0A1551"
    />
    <path
      d="M11.0687 19.1208C10.0442 18.1136 10.0442 16.481 11.0687 15.4739L14.767 11.8396C15.7915 10.8324 17.453 10.8324 18.4777 11.8396C19.5025 12.8465 19.5025 14.4794 18.4777 15.4863L14.7796 19.1208C13.7549 20.1277 12.0934 20.1277 11.0687 19.1208Z"
      fill="#FFB21D"
    />
    <path
      d="M1.29832 9.98844C0.273607 8.98153 0.273607 7.34867 1.29832 6.34177L6.85632 0.879625C7.88108 -0.127518 9.54251 -0.127518 10.5673 0.879625C11.5918 1.88653 11.5918 3.51939 10.5673 4.52629L5.00918 9.98844C3.98442 10.9956 2.32304 10.9956 1.29832 9.98844Z"
      fill="#0099FF"
    />
    <path
      d="M6.38674 14.3509C5.36197 13.3437 5.36197 11.7111 6.38674 10.704L14.796 2.43993C15.8208 1.43278 17.4822 1.43278 18.507 2.43993C19.5315 3.44683 19.5315 5.07969 18.507 6.0866L10.0977 14.3509C9.07293 15.358 7.4115 15.358 6.38674 14.3509Z"
      fill="#FF6100"
    />
  </SvgIcon>
);
